import React, { useCallback } from 'react';
import { injectIntl } from 'react-intl';
import { Button, Modal } from 'antd';

const InHandButton = ({
  submit,
  intl,
  source,
  disabled = false,
  params = {},
}) => {
  const t = intl.messages;

  const handleClick = useCallback(() => {
    Modal.confirm({
      title: t.donation_inhand_modal_title,
      content: t.donation_inhand_modal_body,
      okText: t.yes,
      cancelText: t.no,
      onOk: () => {
        submit({});
      },
    });
  }, [ t, submit ]);


  return (
    <Button
      className="Button-secondary"
      disabled={disabled}
      onClick={handleClick}
    >
      { t.done }
    </Button>
  );
};

export default injectIntl(InHandButton);

